// extracted by mini-css-extract-plugin
module.exports = {"File":"FileList_File__1Ihaj","DeleteFile":"FileList_DeleteFile__AiFNg"};